import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;

  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[600]};

  svg {
    color: ${({ theme }) => theme.colors.gray[600]};
  }

  h1 {
    font-weight: 500;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.gray[600]};
  }
`;
